



























import axios from 'axios'
import { Component, Vue } from 'vue-property-decorator'

@Component
export default class News extends Vue {
  selectedSession:string = ''
  sessions:Array<string> = []
  articles:Array<object> = []
  loading:Boolean = true

  data () {
    return {
      articles: []
    }
  }

  mounted () {
    axios.get('/api/sessions').then(
      response => {
        this.sessions = response.data
        if ('session' in this.$route.params && this.sessions.includes(this.$route.params['session'])) {
          this.selectedSession = this.$route.params['session']
        } else { this.selectedSession = this.sessions[0] }
        this.getSessionPosts()
        this.loading = false
      }
    )
  }

  getSessionPosts () {
    this.loading = true
    axios.get('https://choir.su.hkust.edu.hk/api/news/session/' + this.selectedSession).then(
      response => {
        this.articles = response.data
        this.loading = false
      }
    )
  }

  switchSession () {
    this.$router.push({ name: 'session-news', params: { session: this.selectedSession } })
    this.getSessionPosts()
  }
}
